var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Type } from "class-transformer";
import { IsArray, IsBoolean, IsDate, IsEnum, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
export var VectorizationMigrationStatus;
(function (VectorizationMigrationStatus) {
    VectorizationMigrationStatus["NOT_NEEDED"] = "NOT_NEEDED";
    VectorizationMigrationStatus["PENDING"] = "PENDING";
    VectorizationMigrationStatus["IN_PROGRESS"] = "IN_PROGRESS";
    VectorizationMigrationStatus["COMPLETE"] = "COMPLETE";
})(VectorizationMigrationStatus || (VectorizationMigrationStatus = {}));
export class PatientKbDetailsDto {
}
__decorate([
    IsString()
], PatientKbDetailsDto.prototype, "knowledgeBaseId", void 0);
__decorate([
    IsString()
], PatientKbDetailsDto.prototype, "vectorIndexName", void 0);
export class PatientS3VectorDetailsDto {
}
__decorate([
    IsString()
], PatientS3VectorDetailsDto.prototype, "indexName", void 0);
__decorate([
    IsString()
], PatientS3VectorDetailsDto.prototype, "bucketName", void 0);
__decorate([
    IsNumber()
], PatientS3VectorDetailsDto.prototype, "vectorCount", void 0);
export class VectorizationHistoryItemDto {
}
__decorate([
    IsString()
], VectorizationHistoryItemDto.prototype, "batchId", void 0);
__decorate([
    IsString()
], VectorizationHistoryItemDto.prototype, "status", void 0);
__decorate([
    IsDate(),
    Type(() => Date)
], VectorizationHistoryItemDto.prototype, "startedAt", void 0);
__decorate([
    IsDate(),
    Type(() => Date),
    IsOptional()
], VectorizationHistoryItemDto.prototype, "completedAt", void 0);
__decorate([
    IsString(),
    IsOptional()
], VectorizationHistoryItemDto.prototype, "errorMessages", void 0);
export class PatientVectorizationStatusDto {
}
__decorate([
    IsString()
], PatientVectorizationStatusDto.prototype, "patientId", void 0);
__decorate([
    IsBoolean()
], PatientVectorizationStatusDto.prototype, "hasKBMapping", void 0);
__decorate([
    IsBoolean()
], PatientVectorizationStatusDto.prototype, "hasS3VectorMapping", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => PatientKbDetailsDto)
], PatientVectorizationStatusDto.prototype, "kbDetails", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => PatientS3VectorDetailsDto)
], PatientVectorizationStatusDto.prototype, "s3VectorDetails", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => VectorizationHistoryItemDto)
], PatientVectorizationStatusDto.prototype, "vectorizationHistory", void 0);
__decorate([
    IsBoolean()
], PatientVectorizationStatusDto.prototype, "needsMigration", void 0);
__decorate([
    IsEnum(VectorizationMigrationStatus)
], PatientVectorizationStatusDto.prototype, "migrationStatus", void 0);
export class BatchSummaryDto {
}
__decorate([
    IsString()
], BatchSummaryDto.prototype, "id", void 0);
__decorate([
    IsDate(),
    Type(() => Date)
], BatchSummaryDto.prototype, "createdAt", void 0);
__decorate([
    IsString()
], BatchSummaryDto.prototype, "origin", void 0);
__decorate([
    IsBoolean()
], BatchSummaryDto.prototype, "finalized", void 0);
__decorate([
    IsString(),
    IsOptional()
], BatchSummaryDto.prototype, "documentVectorizationStatus", void 0);
__decorate([
    IsNumber()
], BatchSummaryDto.prototype, "documentCount", void 0);
__decorate([
    IsNumber()
], BatchSummaryDto.prototype, "locationCount", void 0);
__decorate([
    IsNumber()
], BatchSummaryDto.prototype, "tefcaQueryCount", void 0);
export class GlobalAdminPatientDetailsDto {
}
__decorate([
    ValidateNested(),
    Type(() => PatientVectorizationStatusDto)
], GlobalAdminPatientDetailsDto.prototype, "status", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => BatchSummaryDto)
], GlobalAdminPatientDetailsDto.prototype, "batches", void 0);
__decorate([
    IsNumber()
], GlobalAdminPatientDetailsDto.prototype, "fhirRecordCount", void 0);
export class DocumentTaskDto {
}
__decorate([
    IsString()
], DocumentTaskDto.prototype, "id", void 0);
__decorate([
    IsString()
], DocumentTaskDto.prototype, "source", void 0);
__decorate([
    IsString()
], DocumentTaskDto.prototype, "status", void 0);
__decorate([
    IsString(),
    IsOptional()
], DocumentTaskDto.prototype, "filename", void 0);
__decorate([
    IsString()
], DocumentTaskDto.prototype, "locationId", void 0);
__decorate([
    IsString(),
    IsOptional()
], DocumentTaskDto.prototype, "retrievalMetadata", void 0);
__decorate([
    IsDate(),
    Type(() => Date)
], DocumentTaskDto.prototype, "createdAt", void 0);
__decorate([
    IsDate(),
    Type(() => Date)
], DocumentTaskDto.prototype, "updatedAt", void 0);
export class DocumentLocationDto {
}
__decorate([
    IsString()
], DocumentLocationDto.prototype, "id", void 0);
__decorate([
    IsString()
], DocumentLocationDto.prototype, "source", void 0);
__decorate([
    IsString()
], DocumentLocationDto.prototype, "authType", void 0);
__decorate([
    IsString()
], DocumentLocationDto.prototype, "status", void 0);
__decorate([
    IsString()
], DocumentLocationDto.prototype, "organizationId", void 0);
__decorate([
    IsString(),
    IsOptional()
], DocumentLocationDto.prototype, "organizationName", void 0);
__decorate([
    IsString(),
    IsOptional()
], DocumentLocationDto.prototype, "organizationLogoUrl", void 0);
__decorate([
    IsString(),
    IsOptional()
], DocumentLocationDto.prototype, "hcid", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], DocumentLocationDto.prototype, "isExcluded", void 0);
__decorate([
    IsDate(),
    Type(() => Date)
], DocumentLocationDto.prototype, "createdAt", void 0);
__decorate([
    IsDate(),
    Type(() => Date)
], DocumentLocationDto.prototype, "updatedAt", void 0);
__decorate([
    IsNumber()
], DocumentLocationDto.prototype, "documentCount", void 0);
export class TEFCAQueryDto {
}
__decorate([
    IsString()
], TEFCAQueryDto.prototype, "id", void 0);
__decorate([
    IsString()
], TEFCAQueryDto.prototype, "source", void 0);
__decorate([
    IsString()
], TEFCAQueryDto.prototype, "sourceType", void 0);
__decorate([
    IsBoolean()
], TEFCAQueryDto.prototype, "isComplete", void 0);
__decorate([
    IsString(),
    IsOptional()
], TEFCAQueryDto.prototype, "error", void 0);
__decorate([
    IsString(),
    IsOptional()
], TEFCAQueryDto.prototype, "metadata", void 0);
__decorate([
    IsDate(),
    Type(() => Date)
], TEFCAQueryDto.prototype, "createdAt", void 0);
__decorate([
    IsDate(),
    Type(() => Date)
], TEFCAQueryDto.prototype, "updatedAt", void 0);
export class BatchVectorizationDto {
}
__decorate([
    IsString()
], BatchVectorizationDto.prototype, "id", void 0);
__decorate([
    IsString(),
    IsOptional()
], BatchVectorizationDto.prototype, "vectorizationStatus", void 0);
__decorate([
    IsString(),
    IsOptional()
], BatchVectorizationDto.prototype, "ingestionStatus", void 0);
__decorate([
    IsString(),
    IsOptional()
], BatchVectorizationDto.prototype, "knowledgeBaseId", void 0);
__decorate([
    IsString(),
    IsOptional()
], BatchVectorizationDto.prototype, "vectorIndexName", void 0);
__decorate([
    IsString(),
    IsOptional()
], BatchVectorizationDto.prototype, "dataSourceId", void 0);
__decorate([
    IsString(),
    IsOptional()
], BatchVectorizationDto.prototype, "ingestionJobId", void 0);
__decorate([
    IsNumber(),
    IsOptional()
], BatchVectorizationDto.prototype, "documentsScanned", void 0);
__decorate([
    IsNumber(),
    IsOptional()
], BatchVectorizationDto.prototype, "documentsIndexed", void 0);
__decorate([
    IsNumber(),
    IsOptional()
], BatchVectorizationDto.prototype, "documentsModified", void 0);
__decorate([
    IsNumber(),
    IsOptional()
], BatchVectorizationDto.prototype, "documentsDeleted", void 0);
__decorate([
    IsNumber(),
    IsOptional()
], BatchVectorizationDto.prototype, "documentsFailed", void 0);
__decorate([
    IsString(),
    IsOptional()
], BatchVectorizationDto.prototype, "ingestionFailureReasons", void 0);
__decorate([
    IsDate(),
    Type(() => Date)
], BatchVectorizationDto.prototype, "createdAt", void 0);
__decorate([
    IsDate(),
    Type(() => Date)
], BatchVectorizationDto.prototype, "updatedAt", void 0);
export class DocumentDeliveryDto {
}
__decorate([
    IsString()
], DocumentDeliveryDto.prototype, "id", void 0);
__decorate([
    IsString()
], DocumentDeliveryDto.prototype, "patientId", void 0);
__decorate([
    IsDate(),
    Type(() => Date)
], DocumentDeliveryDto.prototype, "createdAt", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], DocumentDeliveryDto.prototype, "createdBatch", void 0);
__decorate([
    IsBoolean()
], DocumentDeliveryDto.prototype, "delivered", void 0);
__decorate([
    IsDate(),
    Type(() => Date),
    IsOptional()
], DocumentDeliveryDto.prototype, "deliveredAt", void 0);
export class BatchDetailDto {
}
__decorate([
    IsString()
], BatchDetailDto.prototype, "id", void 0);
__decorate([
    IsDate(),
    Type(() => Date)
], BatchDetailDto.prototype, "createdAt", void 0);
__decorate([
    IsString()
], BatchDetailDto.prototype, "origin", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], BatchDetailDto.prototype, "isDataUpdate", void 0);
__decorate([
    IsBoolean()
], BatchDetailDto.prototype, "documentSelectionComplete", void 0);
__decorate([
    IsBoolean()
], BatchDetailDto.prototype, "finalized", void 0);
__decorate([
    IsDate(),
    Type(() => Date),
    IsOptional()
], BatchDetailDto.prototype, "patientDeliveryExpiration", void 0);
__decorate([
    IsString(),
    IsOptional()
], BatchDetailDto.prototype, "patientContactMethod", void 0);
__decorate([
    IsString(),
    IsOptional()
], BatchDetailDto.prototype, "pdfFilename", void 0);
__decorate([
    IsString(),
    IsOptional()
], BatchDetailDto.prototype, "pdfStatus", void 0);
__decorate([
    IsString(),
    IsOptional()
], BatchDetailDto.prototype, "documentVectorizationStatus", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => BatchVectorizationDto)
], BatchDetailDto.prototype, "vectorization", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => VectorizationHistoryItemDto)
], BatchDetailDto.prototype, "vectorizationHistory", void 0);
__decorate([
    IsNumber()
], BatchDetailDto.prototype, "documentCount", void 0);
__decorate([
    IsNumber()
], BatchDetailDto.prototype, "locationCount", void 0);
__decorate([
    IsNumber()
], BatchDetailDto.prototype, "tefcaQueryCount", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => DocumentTaskDto)
], BatchDetailDto.prototype, "documents", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => DocumentLocationDto)
], BatchDetailDto.prototype, "locations", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => TEFCAQueryDto)
], BatchDetailDto.prototype, "tefcaQueries", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => DocumentDeliveryDto)
], BatchDetailDto.prototype, "deliveries", void 0);
export class VectorizationMigrationResultDto {
}
__decorate([
    IsString()
], VectorizationMigrationResultDto.prototype, "patientId", void 0);
__decorate([
    IsBoolean()
], VectorizationMigrationResultDto.prototype, "success", void 0);
__decorate([
    IsString()
], VectorizationMigrationResultDto.prototype, "message", void 0);
__decorate([
    IsOptional(),
    IsBoolean()
], VectorizationMigrationResultDto.prototype, "vectorizationJobQueued", void 0);
export class BatchVectorizationMigrationResultDto {
}
__decorate([
    IsNumber()
], BatchVectorizationMigrationResultDto.prototype, "totalPatients", void 0);
__decorate([
    IsNumber()
], BatchVectorizationMigrationResultDto.prototype, "migratedCount", void 0);
__decorate([
    IsNumber()
], BatchVectorizationMigrationResultDto.prototype, "skippedCount", void 0);
__decorate([
    IsNumber()
], BatchVectorizationMigrationResultDto.prototype, "failedCount", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => VectorizationMigrationResultDto)
], BatchVectorizationMigrationResultDto.prototype, "results", void 0);
export class GlobalAdminRetrievalSummaryDto {
}
__decorate([
    IsNumber()
], GlobalAdminRetrievalSummaryDto.prototype, "totalKBPatients", void 0);
__decorate([
    IsNumber()
], GlobalAdminRetrievalSummaryDto.prototype, "totalS3VectorPatients", void 0);
export class PatientsNeedingVectorizationMigrationDto {
}
__decorate([
    IsNumber()
], PatientsNeedingVectorizationMigrationDto.prototype, "count", void 0);
__decorate([
    IsArray(),
    IsString({ each: true })
], PatientsNeedingVectorizationMigrationDto.prototype, "patientIds", void 0);
export class PatientWithVectorizationErrorDto {
}
__decorate([
    IsString()
], PatientWithVectorizationErrorDto.prototype, "patientId", void 0);
__decorate([
    IsDate(),
    Type(() => Date)
], PatientWithVectorizationErrorDto.prototype, "startedAt", void 0);
__decorate([
    IsString()
], PatientWithVectorizationErrorDto.prototype, "status", void 0);
__decorate([
    IsString()
], PatientWithVectorizationErrorDto.prototype, "errorMessages", void 0);
export class PatientsWithVectorizationErrorsDto {
}
__decorate([
    IsNumber()
], PatientsWithVectorizationErrorsDto.prototype, "count", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => PatientWithVectorizationErrorDto)
], PatientsWithVectorizationErrorsDto.prototype, "patients", void 0);
export class RetryFailedChunksResultDto {
}
__decorate([
    IsBoolean()
], RetryFailedChunksResultDto.prototype, "success", void 0);
__decorate([
    IsString()
], RetryFailedChunksResultDto.prototype, "message", void 0);
__decorate([
    IsOptional(),
    IsBoolean()
], RetryFailedChunksResultDto.prototype, "queued", void 0);
export class PatientSearchResultDto {
}
__decorate([
    IsString()
], PatientSearchResultDto.prototype, "id", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientSearchResultDto.prototype, "firstName", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientSearchResultDto.prototype, "lastName", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientSearchResultDto.prototype, "email", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientSearchResultDto.prototype, "dateOfBirth", void 0);
__decorate([
    IsString()
], PatientSearchResultDto.prototype, "status", void 0);
